import {
  AfterContentInit,
  AfterViewInit,
  Component,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Device } from '../../core/models/classes/device';
import { ObjectTypes } from '../../core/models/enums/object-types';
import { Redlining } from '../../core/models/classes/redlining';
import { DeviceService } from '../../core/services/device.service';
import { RedliningService } from '../../core/services/redlining.service';
import { UserService } from '../../core/services/user.service';
import { DataService } from '../../core/services/data.service';
import { Unregister } from '../../core/models/classes/unregister';
import { SystemInfoModel } from '../../core/models/classes/system-info';
import { User } from '../../core/models/classes/user';
import { DeviceValidation } from '../../core/models/classes/device-validation';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UnregisterinfoComponent } from './unregisterinfo/unregisterinfo.component';

@Component({
  selector: 'app-device',
  templateUrl: './device.component.html',
  styleUrls: ['./device.component.scss'],
})
export class DeviceComponent
  implements OnInit, AfterViewInit, AfterContentInit
{
  device: Observable<Device>;
  redls: Observable<Redlining[]>;
  selectedDevice: Device;
  pageTitle: string;
  redDataSource;
  redlinings: Redlining[] = [];
  localRed: Redlining[] = [];
  errorMessage: string;
  btnEnable:string = '0'; //disable copy button
  unregisterEnable:string = '0'; //disable unregister button
  displayedRedColumns: string[] = [
    'id',
    'objectType',
    'name',
    'content',
    'prioritytext'
  ];
  hasLoaded: boolean;
  hasAccess: boolean;
  user: User;
  about: SystemInfoModel;
  objType: typeof ObjectTypes = ObjectTypes;
  devCode: string = '';
  responseCode: string = '';
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private deviceService: DeviceService,
    private userService: UserService,
    private redliningService: RedliningService,
    private dataService: DataService,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar
  ) {
    this.redDataSource = new MatTableDataSource([]);
  }

  ngAfterContentInit(): void {}

  ngAfterViewInit(): void {
    this.redDataSource.sort = this.sort;
  }

  ngOnInit(): void {
    this.getDevice();
    this.getUser();   
  }

  getDevice(){
    const id = +this.route.snapshot.paramMap.get('id');
    this.deviceService.deviceById(id).subscribe({
      next: (data) => {
        this.selectedDevice = data;        
        this.redliningService.getDeviceRedlinings(this.selectedDevice.deviceId).subscribe({
          next: (red) => {
            this.redlinings = red;
            this.redlinings.forEach((x) => {
              x.objectType = ObjectTypes[x.objectType];
            });
            this.redDataSource.data = this.redlinings;
          },
          error: (err) => (this.errorMessage = err),
        });
      },
    });
  }

  getUser(){
    const userId = localStorage.getItem('loginId');
    this.userService.getUserRole(+userId).subscribe({
      next: (data) => {
        if (data !== 3) {
          this.hasAccess = true;
        }
      },
    });
  }

  copyDeleteCode(){
    this._snackBar.open($localize `Device deregistration code copied`, '', {
      duration: 3000
    });
  }

  redliningFilter(event: Event) {
    this.redDataSource.filter = (event.target as HTMLInputElement).value
      .trim()
      .toLowerCase();
  }

  //Generate random code to initiate deregistration of device
  removeDevice() {
    if (this.selectedDevice !== undefined) {
      let unregister = new Unregister();
      const userId = localStorage.getItem('loginId');
      this.userService.getUser(+userId).subscribe({
        next: (data) => {
          this.user = data;
          this.dataService.getAboutStatus().subscribe({
            next: (d: SystemInfoModel) => {
              this.about = d;
              unregister.devId = this.selectedDevice.deviceId;
              unregister.manufactor = this.selectedDevice.manufacturer;
              unregister.name = this.selectedDevice.name;

              unregister.requestedUserName = this.user.name;
              unregister.licensee = this.about.name;
              // let day = new Date();
              // unregister.requestedTime =(day.getDate() + '.' + ((day.getMonth() + 1)) + '.' + day.getFullYear() + ' ' +day.getHours() + ':' + day.getMinutes()+ ':' + day.getSeconds());
              this.btnEnable = '1'; //enable copy button
              this.initiateUnregister(unregister);
            },
          });
        },
      });
    }
  }

  initiateUnregister(unregister: Unregister){
    this.deviceService.GetDeviceCode(unregister).subscribe({
      next: (code) => {
        this.devCode = code;
        this.dialog.open(UnregisterinfoComponent, {
          panelClass: 'custom-dialog-container',
          data: '',
        });
      },
    });
  }

  //Deregister device
  validateAndDeleteDevice() {
    if (this.responseCode !== undefined || this.responseCode !== '') {

      var deviceValidation = new DeviceValidation();
      deviceValidation.key = this.devCode;
      deviceValidation.responseKey = this.responseCode;
      this.deviceService.validateAndRemove(deviceValidation).subscribe({
        next: (data) => {
          if(data.status === 200){
            this._snackBar.open($localize `Device successfully deregistered`, '', {
              duration: 3000
            });
            this.router.navigateByUrl('/default');
          }
        },
      });
    }
  }
}